// TODO: UNIT

export const reorderDraggedItemInArray = <T>(currentIndex: number, newIndex: number, prevState: T[]) => {
    const currentItems = [...prevState];
    currentItems.splice(newIndex, 0, currentItems.splice(currentIndex, 1)[0]);
    return currentItems;
};
